export default __webpack_public_path__ + "static/media/lineicons-original.84130bc2.svg";